export default __webpack_public_path__ + "static/media/Antartica.be4d25ff.jpg";